<app-form-basic
        (closeAction)="close()"
        (saveAction)="sendForm()"
        [service]="service"
        [title]="subtitle"
        class="pop-up-card">
</app-form-basic>
